import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  convertValuesToTarget,
  kpiTypes,
  labels,
  monitoringOptions,
  cumulativeArray
} from "../../../../../utils/useWindowDimensions";

const KpiPlatformUsage = ({ kpi }) => {

  const [cumulative , setCumulative] = useState(false);

  const series = [
    {
      name:  kpi.parameters[0].type === "CUSTOM" ? kpi.parameters[0].name : monitoringOptions[kpi.parameters[0].type],
      data: cumulative ? cumulativeArray(convertValuesToTarget(
                          kpi.parameters[0].values,
                          kpi.parameters[1].duration,
                          kpi.parameters[0].duration
                       ))
            :
            convertValuesToTarget(
                kpi.parameters[0].values,
                kpi.parameters[1].duration,
                kpi.parameters[0].duration
          )
    },
    {
      name: kpi.parameters[1].type
        ? kpi.parameters[1].name
        : monitoringOptions[kpi.parameters[1].type],
      data: cumulative ? cumulativeArray(kpi.parameters[1].values) : kpi.parameters[1].values,
    },
  ];
  const options = {
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: labels[kpi.parameters[1].duration],
    },
    colors: ["#333333", "#3e4095"],
  };

  switch(kpi.graphType)
  {
    case 'BAR':
        options.chart.type = 'bar'
        break;
    case 'LINE':
        options.chart.type = 'line'
        break;
    case 'MIXED':
        options.chart.type = 'line'
        series[0].type = 'column'
        series[1].type = 'line'
        break;
  }

  return (
    <>
      <div id="chart">
       <div className="row">
        <div className="col-md-6 d-flex align-itmes-center justify-content-start"><h6>{kpi.title}</h6></div>
        <div className="col-md-6 d-flex align-itmes-center justify-content-end">

       
          <FormControl size="small">
              <Select
                  className="p-0"
                  value={cumulative}
                  onChange={(e) => setCumulative(e.target.value)}
              >
                  <MenuItem value={false}>Normal</MenuItem>
                  <MenuItem value={true}>Cumulative</MenuItem>
              </Select>
          </FormControl>
          </div>
        </div> 
        <ReactApexChart
          options={options}
          series={series}
          type={options.chart.type}
          height={250}
        />
      </div>
    </>
  );
};

export default KpiPlatformUsage;
